import { withInstall } from '../utils'
import _CountDown from './Countdown'

export const CountDown = withInstall(_CountDown)
export default CountDown
